import { NotificationState, notificationActions } from '@om1/platform-notifications'
import { connectRedux } from '@om1/platform-utils'
import { TimeoutDialogComponent } from './TimeoutDialogComponent'

export function createTimeoutDialog<TState extends { notification: NotificationState }>() {
    return connectRedux(TimeoutDialogComponent, (state: TState) => state.notification, { ...notificationActions })
}

export type TimeoutDialog = ReturnType<typeof createTimeoutDialog>
